// const countdown = require('countdown');

const { TRAVIS } = window;
// console.log('countdown', countdown);

function isValidDate(d) {
  // eslint-disable-next-line no-restricted-globals
  return d instanceof Date && !isNaN(d);
}

function normalizeDate(dateString) {
  // Check if timezone info is present
  const hasTimezone = /GMT|UTC|[+-]\d{2}:\d{2}|[+-]\d{4}/.test(dateString);
  let normalized = dateString;

  if (!hasTimezone) {
    // Add New York timezone (EST = GMT-0500) if missing
    normalized = `${dateString} GMT-0500`;
  }

  // Convert YYYY-MM-DD format to browser-friendly format
  // "2025-11-18 11:00:00 GMT-0500" -> "Nov 18 2025 11:00:00 GMT-0500"
  const isoMatch = normalized.match(/^(\d{4})-(\d{2})-(\d{2})\s+(.+)$/);
  if (isoMatch) {
    const [, year, month, day, rest] = isoMatch;
    const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
    const monthName = months[parseInt(month, 10) - 1];
    normalized = `${monthName} ${parseInt(day, 10)} ${year} ${rest}`;
  }

  return normalized;
}

export default class CountDown {
  constructor(el) {
    this.el = el || document.querySelector('.js-countdown');
    if (!this.el) return; // console.log('countdown: el not found');
    let end_time = TRAVIS.cd_date || this.el.getAttribute('data-date');
    if (!end_time) return;

    // Normalize date format and add timezone if missing
    end_time = normalizeDate(end_time);

    // Get completion behavior options
    this.completionBehavior = this.el.getAttribute('data-completion-behavior') || 'hide';
    this.completionMessage = this.el.getAttribute('data-completion-message') || '';
    this.completionEl = this.el.querySelector('.CD__complete');

    this.el.style.display = 'block';
    this.opts = [
      'days',
      'hours',
      'minutes',
      'seconds',
      // 'milliseconds',
    ];
    this.prev = {};
    this.els = this.opts.map((o) => this.el.querySelector(`.js-${o}`));
    this.separators = [];

    const now = new Date();
    const endDate = new Date(end_time);

    if (!isValidDate(endDate)) {
      console.error('invalid date', end_time);
      return this.turnOff();
    }
    if (now > endDate) return this.handleCompletion();

    const { DAYS, HOURS, MINUTES, SECONDS } = window.countdown;
    /* eslint no-bitwise:0 */
    this.el.classList.add('js-init');
    this.countdownTimer = window.countdown(
      endDate,
      this.tick.bind(this),
      DAYS | HOURS | MINUTES | SECONDS
    );
  }

  tick(ts) {
    // positive values means end < start
    if (ts.value >= 0) {
      this.handleCompletion();
      return;
    }

    this.opts.forEach((opt, i) => {
      if (!this.els[i]) return;

      const elContainer = this.els[i].parentNode;
      const nextSep = elContainer?.nextElementSibling;

      // Hide days if zero
      if (opt === 'days') {
        if (Number(ts[opt]) === 0) {
          elContainer.style.display = 'none';
          if (nextSep?.classList.contains('CD__sep')) {
            nextSep.style.display = 'none';
          }
        } else {
          elContainer.style.display = '';
          if (nextSep?.classList.contains('CD__sep')) {
            nextSep.style.display = '';
          }
        }
      }

      // Hide hours if zero AND days are also zero
      if (opt === 'hours' && Number(ts.days) === 0) {
        if (Number(ts[opt]) === 0) {
          elContainer.style.display = 'none';
          if (nextSep?.classList.contains('CD__sep')) {
            nextSep.style.display = 'none';
          }
        } else {
          elContainer.style.display = '';
          if (nextSep?.classList.contains('CD__sep')) {
            nextSep.style.display = '';
          }
        }
      }

      // Only update innerHTML if value changed
      if (this.prev[opt] && this.prev[opt] === ts[opt]) return;

      let time = ts[opt];
      if (opt === 'days') {
        time = ts[opt].toString(); // Remove leading zero for days
      } else if (opt === 'milliseconds') {
        time = ts[opt];
        if (ts[opt] < 100) {
          time = `0${ts[opt]}`;
        }
        if (ts[opt] < 10) {
          time = `00${ts[opt]}`;
        }
      } else {
        time = ts[opt] < 10 ? `0${ts[opt]}` : ts[opt];
      }
      this.els[i].innerHTML = time;
      this.prev[opt] = ts[opt];
    });
  }

  handleCompletion() {
    if (this.countdownTimer) clearInterval(this.countdownTimer);

    switch (this.completionBehavior) {
      case 'message':
        // Hide the timer, show the completion message
        const timeEl = this.el.querySelector('.CD__time');
        if (timeEl) timeEl.style.display = 'none';
        if (this.completionEl) {
          this.completionEl.style.display = 'block';
          this.completionEl.innerHTML = this.completionMessage;
        }
        this.el.classList.add('js-complete');
        break;

      case 'reload':
        // Reload the page after a short delay
        this.turnOff();
        setTimeout(() => {
          window.location.reload();
        }, 3000);
        break;

      case 'hide':
      default:
        // Hide the countdown entirely
        this.turnOff();
        break;
    }
  }

  turnOff() {
    if (this.el) {
      this.el.classList.remove('js-init');
      this.el.style.display = 'none';
    }
    if (this.countdownTimer) clearInterval(this.countdownTimer);
    // this will cause a reload for whatever needs to happen to show.
  }
}
